<template>
    <div
        id="section-elements"
        class="personality-section">

        <div class="vertical-sep vertical-sep--top"></div>

        <!-- <h2 class="personality-section__title">{{ $t("x-and-y-are-predominant—for-you", {x: $t(elementsSorted[0].traits), y: $t(elementsSorted[1].traits)}) }}</h2> -->


        <h2 class="personality-section__title">{{ title }}</h2>

        <div class="personality-section__content">

            <div class="personality__subsection">

                <ul class="elements list--unstyled">
                    <li
                        v-if="firelove"
                        class="element">
                        <div
                            class="element__icon"
                            aria-hidden="true">

                            <donut
                                class="element__donut"
                                :value="firelove.points_perc"
                                color="#e37470" />

                            <img
                                class="element__icon-svg"
                                src="@/assets/images/artworks/who-i-am/elements/fire.svg"
                                alt="" />
                        </div>

                        <h3 class="element__name">{{ $t("firelove") }}</h3>
                        <p class="element__score">{{ firelove.points_perc }}%</p>
                    </li>
                    <li
                        v-if="earthlove"
                        class="element">
                        <div
                            class="element__icon"
                            aria-hidden="true">

                            <donut
                                class="element__donut"
                                :value="earthlove.points_perc"
                                color="#aad681" />

                            <img
                                class="element__icon-svg"
                                src="@/assets/images/artworks/who-i-am/elements/earth.svg"
                                alt="" />
                        </div>
                        <h3 class="element__name">{{ $t("earthlove") }}</h3>
                        <p class="element__score">{{ earthlove.points_perc }}%</p>
                    </li>
                    <li
                        v-if="airlove"
                        class="element">
                        <div
                            class="element__icon"
                            aria-hidden="true">

                            <donut
                                class="element__donut"
                                :value="airlove.points_perc"
                                color="#fae087" />

                            <img
                                class="element__icon-svg"
                                src="@/assets/images/artworks/who-i-am/elements/air.svg"
                                alt="" />
                        </div>
                        <h3 class="element__name">{{ $t("airlove") }}</h3>
                        <p class="element__score">{{ airlove.points_perc }}%</p>
                    </li>
                    <li
                        v-if="waterlove"
                        class="element">
                        <div
                            class="element__icon"
                            aria-hidden="true">

                            <donut
                                class="element__donut"
                                :value="waterlove.points_perc"
                                color="#7ae0d9" />

                            <img
                                class="element__icon-svg"
                                src="@/assets/images/artworks/who-i-am/elements/water.svg"
                                alt="" />
                        </div>
                        <h3 class="element__name">{{ $t("waterlove") }}</h3>
                        <p class="element__score">{{ waterlove.points_perc }}%</p>
                    </li>
                </ul>
            </div>

            <div class="grid">
                <div class="grid__item desktop--5 desktop--push--1">
                    <h4 class="title--3">{{ $t("firelove") }}</h4>
                    <div v-html="$t('fire-description')"></div>
                </div>
                <div class="grid__item desktop--5 desktop--push--1">
                    <h4 class="title--3">{{ $t("earthlove") }}</h4>
                    <div v-html="$t('earth-description')"></div>
                </div>
                <div class="grid__item desktop--5 desktop--push--1">
                    <h4 class="title--3">{{ $t("airlove") }}</h4>
                    <div v-html="$t('air-description')"></div>
                </div>
                <div class="grid__item desktop--5 desktop--push--1">
                    <h4 class="title--3">{{ $t("waterlove") }}</h4>
                    <div v-html="$t('water-description')"></div>
                </div>
            </div>

            <slot></slot>

        </div>

        <div class="vertical-sep vertical-sep--bottom"></div>

    </div>
</template>


<script>

import Donut from "@/components/charts/Donut.vue";

export default {
    components: {
        "Donut": Donut
    },

    props: {
        data: {
            type: Array,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: "perso"
        },
        user: {
            type: Object,
            required: false,
            default() {
                return {};
            }
        }
    },

    computed: {
        firelove() {
            const index = this.getObjetIndexByKey(this.data, "traits", "feu");

            return this.data[index];
        },
        earthlove() {
            const index = this.getObjetIndexByKey(this.data, "traits", "terre");

            return this.data[index];
        },
        airlove() {
            const index = this.getObjetIndexByKey(this.data, "traits", "air");

            return this.data[index];
        },
        waterlove() {
            const index = this.getObjetIndexByKey(this.data, "traits", "eau");

            return this.data[index];
        },
        elementsSorted() {

            let array = this.data;

            array.sort((a, b) => {
                return b.points_perc - a.points_perc;
            });

            return array;
        },
        title() {
            if (this.type === "other") {
                return this.$t("x-and-y-relationship-are-predominant—for-other", {x: this.$t(this.elementsSorted[0].traits), y: this.$t(this.elementsSorted[1].traits), z: this.user.fname});
            } else if (this.type === "group") {
                return this.$t("x-and-y-are-predominant—for-group", {x: this.$t(this.elementsSorted[0].traits), y: this.$t(this.elementsSorted[1].traits)});
            } else {
                return this.$t("x-and-y-relationship-are-predominant—for-other", {x: this.$t(this.elementsSorted[0].traits), y: this.$t(this.elementsSorted[1].traits)});
            }
        }
    },

    mounted() {
    },

    destroyed() {

    },


    methods: {

    },
};
</script>